import { ProgressBar } from "react-bootstrap"

function progressBarVariant(total_size){
  if(total_size <= 49){
    return 'success'
  } else if (total_size <= 50 && total_size < 80) {
    return `warning`
  } else {
    return 'danger'
  }
}

function WorkspaceFileLimitBar({ workspace, className = "m-2 text-right", lg }) {
    if(workspace === undefined || workspace === null) return;
    
    const is_large = lg ? "lg" : ""
    const display_text = `${workspace.total_size}% of ${workspace.size_limit} GB used`

    return(
        <div className={`personal_workspace-progress ${is_large} ${className}`}>
            <ProgressBar variant={progressBarVariant(workspace.total_size)} now={workspace.total_size} max={100}/>
            { display_text }
        </div>
    )
}

export default WorkspaceFileLimitBar